export default theme => ({
  flex: {
    flexGrow: 1
  },
  list: {
    width: 250
  }
})
